<template>
  <div id="app">
    <div id="app-content-wrapper" class="d-flex flex-grow-1 ">
      <!-- <sidemenu v-if="showSidebar" /> -->
      <div class="sidebar-wrapper">
        <Sidebar v-if="showSidebar" />
      </div>
      <transition name="fade">
        <SubscriptionCountdownBanner v-if="bannerDelay && showSubscriptionBanner" />
      </transition>
      <transition name="standard-fade">
        <PostDemoGuide
          v-if="guideIsReady && $store.state.postDemoGuide && $store.state.showDemoGuide"
          @close="$store.commit('showDemoGuide', false)"
        />
      </transition>
      <router-view class="flex-grow-1" :class="{ 'loading-overlay': loadingRoute }" />
      <transition name="delay">
        <div v-show="loadingRoute">
          <i class="fa-light fa-circle-notch fa-spin loading-overlay-circle"></i>
        </div>
      </transition>
    </div>
    <modals-container />
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/css/quill.snow.css";
import Sidemenu from "@/components/Sidemenu";
import Sidebar from "@/components/Sidebar";
import SubscriptionCountdownBanner from "@/components/SubscriptionCountdownBanner";
import PostDemoGuide from "@/components/PostDemoGuide";
import EventBus from "@/assets/js/eventBus.js";
export default {
  //     methods: {
  //   detectClick(event) {
  //     // event.target is the clicked element object
  //     console.log(event.target)
  //     console.log(this._uid)
  //   }
  // },
  data() {
    return {
      bannerDelay: false
    };
  },
  computed: {
    showSidebar() {
      return (
        [
          "template",
          "login",
          "signup",
          "signupflow",
          "reset-password",
          "forgot-password",
          "demo",
          "demo.signup"
        ].indexOf(this.$route.name) == -1
      );
    },
    showSubscriptionBanner() {
      if (this.$route.name == "settings.subscription") {
        return false;
      } else return this.$store.getters.trialEnding;
    },
    loadingRoute() {
      return this.$store.state.loadingRoute;
    },
    guideIsReady() {
      return this.$store.getters.guideIsReady;
    },

    postDemoGuide() {
      return this.$store.state.postDemoGuide;
    },

    showDemoGuide() {
      return this.$store.state.showDemoGuide;
    }
  },
  mounted() {
    setTimeout(() => {
      this.bannerDelay = true;
    }, 2000);
  },
  components: {
    Sidebar,
    SubscriptionCountdownBanner,
    PostDemoGuide
  }
};
</script>

<style lang="less">
@import url(./assets/css/tooltip.less);
// @import url("https://use.typekit.net/jmf5cfw.css");
:root {
  --scrollbarBG: #3d464a;
  --scrollbarBGLight: #fff;
  --scrollbarBGGrey: #f1f1f1;
  --thumbBG: #666f73;
  --thumbBGLighter: rgb(158, 167, 172);

  scrollbar-face-color: var(--thumbBG); /* Firefox 63 compatibility */
  scrollbar-track-color: var(--scrollbarBG); /* Firefox 63 compatibility */
  scrollbar-color: var(--thumbBG) var(--scrollbarBG);
  scrollbar-width: thin;

  --background-white: #fff;
  --bg-grey: #f8f8f8;
  --text-grey-primary: #8f979c;
  --text-grey-secondary: #848c8e;
  --alabaster: #f2f0e7;
  --alabaster-80: #f2f0e780;
  --alabaster-60: #f2f0e760;
  --alabaster-40: #f2f0e741;
  --charcoal: #3f464a;
  --charcoal-75: rgba(63, 70, 74, 0.75);
  --charcoal-50: rgba(63, 70, 74, 0.5);
  --charcoal-20: rgba(63, 70, 74, 0.2);
  --charcoal-10: rgba(63, 70, 74, 0.1);
  --charcoal-115: #353b3f;
  --charcoal-border: #485258;
  --hover-white: rgba(204, 204, 204, 0.2);

  --flame-gradient: linear-gradient(-120deg, rgba(246, 162, 28, 1) 30%, rgba(235, 94, 52, 1) 70%);
  --flame-gradient-20: linear-gradient(-120deg, rgba(246, 162, 28, 0.2) 30%, rgba(235, 94, 52, 0.2) 70%);
  --flame-gradient-10: linear-gradient(-120deg, rgba(246, 162, 28, 0.1) 30%, rgba(235, 94, 52, 0.1) 70%);
  --flame: #eb5e34;
  --flame-40: rgba(235, 94, 52, 0.4);
  --flame-20: rgba(235, 94, 52, 0.2);
  --flame-10: rgba(235, 94, 52, 0.1);
  --orange-web: #f6a21c;
  --orange-web-80: rgba(246, 162, 28, 0.8);
  --orange-web-60: rgba(246, 162, 28, 0.6);
  --orange-web-40: rgba(246, 162, 28, 0.4);
  --orange-web-20: rgba(246, 162, 28, 0.2);
  --orange-web-10: rgba(246, 162, 28, 0.1);

  --bg-cream: #fff7f0;

  --signup-aside: var(--bg-cream);

  --standard-border-radius: 10px;
  --success-green: #28a745;
  --danger-red: #dc3545;

  --ai-primary: #8a2be2;
  --ai-secondary: #a35aff;
  --ai-secondary-40: #a45aff6d;
  --ai-secondary-10: #a45aff10;
  --ai-tertiary: #6b48ff;
  --ai-tertiary-75: rgba(107, 72, 255, 0.75);
  --ai-tertiary-50: rgba(107, 72, 255, 0.5);

  --sidebar-width: calc(81px + 18px + 18px);
  --auto-max-width: 1350px;
}
// @font-face {
//   font-family: "3954";
//   src: url("./fonts/futura/3954.eot");
//   src: local("3954"), url("./fonts/futura/3954.woff") format("woff"), url("./fonts/futura/3954.ttf") format("truetype");
// }
#app {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #3D464A;
  color: var(--charcoal);
  display: flex;
  // flex-direction: column;

  .sidebar-wrapper {
    position: relative;
  }

  h1,
  h2,
  h3,
  h4 {
    font-family: "Open Sans", sans-serif;
    font-weight: 800;
  }

  h1 {
    font-size: 24px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
    font-weight: 700;
  }
  h4 {
    font-size: 14px;
  }

  #editor {
    // flex: 1 1 auto;
    display: flex;
    height: 100%;
  }

  button:focus {
    outline: 2px solid lightgray;
  }
  select:focus {
    outline: 2px solid lightgray;
    outline-offset: 1px;
  }

  .v--modal {
    border-radius: var(--standard-border-radius);
  }
  .v--modal-background-click {
    overflow: auto;
  }

  .editor-modal {
    .footer {
      display: flex;
      // justify-content: flex-end;
      button + button {
        margin-left: 10px;
      }
    }
  }
  .text-success {
    color: var(--success-green);
  }
  .text-warning {
    color: var(--orange-web);
  }
  .text-danger {
    color: var(--danger-red);
  }
  .text-small {
    font-size: 12px;
  }
  .text-xs {
    font-size: 10px;
  }
  .text-xxs {
    font-size: 8px;
  }
  .text-disabled {
    color: var(--charcoal-50);
  }
  .text-strong {
    font-weight: 500;
  }
  .text-extra-strong {
    font-weight: 700;
  }
  .text-muted {
    color: var(--text-grey-primary) !important;
  }
  .text-semibold {
    font-weight: 500;
  }

  .break-top {
    margin-top: 12px;
  }

  .select-dropdown {
    position: relative;
    display: flex;
    flex-flow: column;
    label {
      color: #8f979c;
      font-weight: bold;
      font-size: 14px;
      transform-origin: 0 0;
      transform: translate(0px, 10px) scale(0.8);
    }
    select {
      overflow-x: auto;
      font-size: 14px;
      border: none;
      border-bottom: 1px solid #ccc;
      font-family: inherit;
      padding: 10px 0;
      cursor: text;
      font-weight: 500;
      background-color: inherit;
      color: var(--charcoal);
      //removes the 3px padding-left (or so) in dropdown BUT also removes the chevron down - so we add that ourselves
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-image: url("../src/assets/svg/chevronDown.svg");
      background-repeat: no-repeat;
      background-position: 99% 50%;
      background-size: 8px;
    }
  }

  .dropdown.invalid {
    label {
      color: var(--danger-red);
    }
    select {
      border-color: var(--danger-red);
    }
  }
  .form-group {
    label {
      color: #8f979c;
      font-size: 12px;
      font-weight: bold;
    }
    input,
    select {
      &.form-control {
        background: transparent;
        font-weight: 500;
        font-size: 14px;
        border-width: 0;
        border-bottom: 1px solid #c4c4c4;
        border-radius: 0;
        // border-color: #c4c4c4;
        padding: 10px 8px 10px 0;
        // line-height: 14px;
        height: unset;
        &::placeholder {
          color: #8f979c;
        }

        &[readonly]::placeholder {
          color: #383838;
        }

        &:focus,
        &:active {
          box-shadow: none;
          border-color: #c4c4c4;
        }
      }
    }

    select {
      &.empty {
        color: #8f979c;
      }

      option {
        font-size: 14px;
      }

      option:not(.default) {
        color: #222;
      }
    }
  }

  .btn {
    // border-radius: 2px;
    border-radius: 20px;
  }

  .btn-rounded-tertiary {
    font-size: 12px;
    border-radius: 8px;
    padding: 4px 12px;
    background: none;
    border: 1px solid var(--charcoal-50);
    color: var(--charcoal-50);
    white-space: nowrap;
  }
  .btn-icon-only {
    padding: 0;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.1s;
    // border-color: var(--orange-web);
    background-color: #f8f8f8;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    span {
      font-size: 14px;
    }

    &:hover {
      border-radius: 8px;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    }
  }

  .btn-notification {
    position: relative;
    ::after {
      content: "";
      position: absolute;
      top: -4px;
      right: -4 px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: var(--orange-web);
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.10);
    }
  }

  .btn-xs {
    color: var(--charcoal);
    padding: 0.15rem 0.5rem;
    font-size: 12px;
    line-height: 1.5;
    // border-radius: .15rem;
  }

  .btn-sm {
    padding: 5px 20px;
    font-size: 12px;
  }

  .btn-md {
    // padding: 8px 30px;
    padding: 6px 20px;
    font-size: 12px;
  }
  .btn-flex {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-primary {
    border-color: var(--orange-web);
    font-weight: 500;
    background-color: var(--orange-web);
    color: #fff;

    // &:hover {
    //   background-color: unset;
    //   color: var(--orange-web);
    // }
  }
  .btn-primary-outline {
    border-color: var(--orange-web);
    color: var(--orange-web);
    font-weight: 500;
    background-color: transparent;
  }

  .btn-primary,
  .btn-secondary,
  .btn-primary-outline {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    font-size: 12px;
    font-family: "Open Sans", sans-serif;
    font-weight: 700;
    &:hover {
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    }

    &:active,
    &.focus {
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    }
  }

  .btn-secondary {
    // background-color: #fafafa;
    // border-color: #fafafa;
    // color: #8f979c;
    font-weight: 500;

    background: none;
    border: 1px solid var(--charcoal-50);
    color: var(--charcoal-50);
    box-shadow: unset;
  }

  .btn-invert {
    background-color: transparent;
    color: var(--orange-web);
    &:hover {
      background-color: var(--orange-web);
      color: var(--alabaster);
    }
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  a {
    color: var(--orange-web);
    cursor: pointer;
  }

  .flip-chevron {
    transform: rotate(180deg);
  }

  .main-list-wrapper {
    background-color: var(--background-white);
    border-radius: var(--standard-border-radius);
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
    // width: calc(100% - 40px);
    width: 100%;
    min-height: calc(100vh - 24px - 35px - 24px - 16px - 40px - 200px);
    margin: 40px auto;
  }

  // @media screen and (max-width: 620px) {
  //   .main-list-wrapper {
  //     width: 100%;
  //   }
  // }

  .selector {
    // background-image: url("../src/assets/svg/chevronDown.svg");
    background-repeat: no-repeat;
    background-position: 95% 50%;
    background-size: 15px;
    // appearance: none;
  }
  // scrollbar styling

  *::-webkit-scrollbar {
    width: 8px;
  }
  * {
    scrollbar-face-color: var(--thumbBG); /* Firefox 63 compatibility */
    scrollbar-track-color: var(--scrollbarBG); /* Firefox 63 compatibility */
    scrollbar-color: var(--thumbBG) var(--scrollbarBG);
    scrollbar-width: thin;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }

  .custom-scrollbar {
    //scrollbar styling // Should work for Chrome and Edge
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--thumbBG) var(--scrollbarBG);

    &::-webkit-scrollbar {
      // display: none;
      cursor: pointer;
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--scrollbarBG);
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--thumbBG);
      border-radius: 6px;
      border: 2px solid var(--scrollbarBG);
    }
  }
  .custom-scrollbar-light {
    // overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--thumbBG) var(--scrollbarBGLight);
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--scrollbarBGLight);
      // box-shadow: inset 0 0 8px -2px rgba(0, 0, 0, 0.25);
      // box-shadow: 0px 0px 8px -1px rgba(0, 0, 0, 0.25) inset;
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--thumbBG);
      border-radius: 6px;
      border: 2px solid var(--scrollbarBGLight);
    }
  }
  .custom-scrollbar-grey {
    // overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--thumbBG) var(--scrollbarBGGrey);
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--thumbBG);
      border-radius: 6px;
      border: 2px solid var(--scrollbarBGGrey);
    }
  }
  .custom-scrollbar-grey-on-grey {
    // overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--thumbBG) var(--scrollbarBGGrey);
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--thumbBG);
      border-radius: 6px;
      border: 2px solid #333a3e;
    }
  }
  .hide-bottom-scrollbar {
    overflow: hidden;
    overflow-y: auto;
  }

  // th.sorted {
  //   &:after{
  //     content: '';
  //     position: relative;
  //     // top: 10px;
  //     // left: 10px;
  //     height: 5px;
  //   }

  //   &.desc:after {
  //       border-left: 5px solid transparent;
  //       border-right: 5px solid transparent;
  //       border-top: 5px solid #383838;
  //       transform: rotate(180deg);
  //       display: inline-block;
  //     }

  //     &.asc:after {
  //       border-left: 5px solid transparent;
  //       border-right: 5px solid transparent;
  //       border-top: 5px solid #383838;
  //     }
  // }

  // .fade-enter-from{
  //     opacity: 0;
  // }
  .fade-enter-to {
    opacity: 1;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.4s ease;
    transition-delay: 1s;
  }
  .quick-fade-in-enter-to {
    opacity: 1;
  }
  .quick-fade-in-enter {
    opacity: 0;
  }
  .quick-fade-in-enter-active {
    transition: all 0.2s ease;
  }

  // editor popover footer action buttons (save and cancel)

  .save-footer {
    // box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    display: flex;
    position: relative;
    align-items: center;
    // background-color: #fff;
    background: #fff;
    height: 35px;
    color: #3d464a;
    text-align: center;
    border-top: 1px solid #3d464a5d;
    // z-index: 3;
    .save,
    .cancel {
      flex: 1 1 auto;
      line-height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .cancel {
      cursor: pointer;
    }

    .save {
      color: #3d464a70;
      border-left: 1px solid #3d464a5d;
      pointer-events: none;
    }

    &.can-save {
      .save {
        color: #3d464a;
        pointer-events: auto;
        cursor: pointer;

        &:hover {
          color: #000;
        }
      }
    }
    svg {
      margin-left: 4px;
    }
  }

  .loading-overlay {
    transition-delay: 0.2s;
    transition: 0.1s;
    filter: blur(4px);
  }
  .loading-overlay-circle {
    font-size: 32px;
    color: rgba(61, 70, 74, 0.39);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(calc(-50% + 85px), -50%);
  }
  .delay-enter-to {
    opacity: 0.5;
  }
  .delay-enter,
  .delay-leave-to {
    opacity: 0;
  }
  .delay-enter-active {
    transition: all 0.2s ease;
    transition-delay: 0.6s;
  }
  .draghandle {
    cursor: grab;
  }
  .is-dragging {
    cursor: grabbing !important;
  }
  .drag-grip {
    cursor: grab;
    height: auto;
    width: 8px;
    > img {
      pointer-events: none;
    }
  }

  .deleting-source {
    filter: blur(2px) brightness(90%);
    transition-delay: 0.2s;
    transition: 0.1s;
  }
  .deleting-source-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    z-index: 1;
  }

  .standard-fade-enter-to {
    opacity: 0.5;
  }
  .standard-fade-enter,
  .standard-fade-leave-to {
    opacity: 0;
  }
  .standard-fade-enter-active {
    transition: all 0.1s ease;
  }

  .login-type-page {
    h1 {
      font-family: "Open Sans", sans-serif;
      text-transform: unset;
      color: var(--orange-web);
      margin-bottom: 80px;
      font-size: clamp(24px, 5vw, 36px);
    }
    h2,
    h3,
    h4 {
      font-family: "Open Sans", sans-serif;
      text-transform: unset;
      font-size: 18px;
    }
    h3,
    h4 {
      font-size: 14px;
    }

    .btn-signup-flow,
    .btn-login {
      border: none;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      width: 100%;
      text-align: left;
      padding: 12px 18px;
      font-weight: 700;
      color: var(--orange-web);
      background: var(--orange-web-20);
      margin-bottom: 4px;

      &:hover {
        background: var(--orange-web-40);
      }

      &:disabled {
        background: var(--orange-web-10);
        color: var(--orange-web-40);
        cursor: not-allowed;
      }
    }
  }

  .auto-max-width {
    max-width: calc(var(--auto-max-width) - calc(var(--sidebar-width) + 36px));
    margin: 0 auto;
  }
}
</style>
